<script setup lang="ts">
    import { useShippingStore } from '@/stores/shippingStore';
    import { packageMetadata } from './shippingPackageMetadata';
    import { longDate } from '@/formatters';
    import PackageRemarks from './PackageRemarks.vue';

    const store = useShippingStore();
</script>

<template>
    <div class="mb-3">
        <div class="shipping-section-header">
            General:
        </div>
        <table class="table is-striped is-narrow is-fullwidth">
            <tbody>
                <tr>
                    <th>Package type</th>
                    <td>
                        <b-icon
                            :icon="packageMetadata.type.icon(store.selectedPackage!.packageType)"
                            size="is-small" />
                        {{ packageMetadata.type.displayAs(store.selectedPackage!.packageType) }}
                    </td>
                </tr>
                <tr>
                    <th>Status</th>
                    <td>
                        <b-icon
                            :icon="packageMetadata.status.icon(store.selectedPackage!.status)"
                            :custom-class="packageMetadata.status.class(store.selectedPackage!.status)"
                            size="is-small" />
                        {{ packageMetadata.status.displayAs(store.selectedPackage!.status) }}
                    </td>
                </tr>
                <tr>
                    <th>Package ID</th>
                    <td>
                        {{ store.selectedPackage!.packageId }}
                    </td>
                </tr>
                <tr>
                    <th>Description</th>
                    <td>
                        {{ store.selectedPackage!.description }}
                    </td>
                </tr>
                <tr>
                    <th>Date created</th>
                    <td>
                        {{ longDate(store.selectedPackage!.dateCreated) }} UTC
                    </td>
                </tr>
                <tr>
                    <th>Date updated</th>
                    <td>
                        {{ longDate(store.selectedPackage!.dateUpdated) }} UTC
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="mb-3">
        <div class="shipping-section-header">
            Remarks:
        </div>
        <package-remarks />
    </div>
    <div class="mb-3">
        <div class="shipping-section-header">
            Export properties:
        </div>
        <table class="table is-striped is-narrow is-fullwidth">
            <tbody>
                <tr>
                    <th>Extracted from</th>
                    <td>
                        {{ store.selectedPackage!.extractedFromSystem }}
                    </td>
                </tr>
                <tr>
                    <th>Extracted by</th>
                    <td>
                        {{ store.selectedPackage!.extractedByUserId }}
                    </td>
                </tr>
                <tr>
                    <th>Prinsipal name</th>
                    <td>
                        {{ store.selectedPackage!.extractedByUserPrincipalName }}
                    </td>
                </tr>
                <tr>
                    <th>Date extracted</th>
                    <td>
                        {{ longDate(store.selectedPackage!.dateExtracted) }} UTC
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div
        v-show="store.selectedPackage!.uploadedByUserId"
        class="mb-3">
        <div class="shipping-section-header">
            Import properties:
        </div>
        <table class="table is-striped is-narrow is-fullwidth">
            <tbody>
                <tr>
                    <th>Uploaded by</th>
                    <td>
                        {{ store.selectedPackage!.uploadedByUserId }}
                    </td>
                </tr>
                <tr>
                    <th>Date uploaded</th>
                    <td>
                        {{ longDate(store.selectedPackage!.dateUploaded) }} UTC
                    </td>
                </tr>
                <tr>
                    <th>Date imported</th>
                    <td>
                        {{ longDate(store.selectedPackage!.dateImported) }} UTC
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
